import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as technicianActions from 'actions/technicianActions';
import {
  Header,
  HeaderButtonNav,
  HeaderButton,
  HeaderTitle,
} from 'components/layout';
import * as operationsApi from 'api/operationsApi';
import TechnicianListTable from './TechnicianListTable';
import { useNavigate } from 'react-router-dom';

/*class TechnicianList extends Component {
  state = {
    showOverlay: false,
    loaded: false,
    technicians: []
  };

  componentDidMount() {
    operationsApi.getTechnicians().then(result => {
      this.setState({
        loaded: true,
        technicians: result.data
      });
    });
  }*/
const TechnicianList = (props) => {
  const [showOverlay, setShowOverlay] = useState(false);
  const [loaded, setLoaded] = useState(false);
  const [technicians, setTechnicians] = useState([]);

  const navigate = useNavigate();

  useEffect(() => {
    const fetchTechnicians = async () => {
      const result = await operationsApi.getTechnicians();
      setTechnicians(result.data);
      setLoaded(true);
    };

    fetchTechnicians();
  }, []); // Empty dependency array means this runs once after the initial render

  const toggleNavigation = () => {
    this.setState((prevState) => ({
      showOverlay: !prevState.showOverlay,
    }));
  };

  const handleRowClick = (row) => {
    // this.props.history.push('/technicians/edit/' + row.id);
    navigate('/technicians/edit/' + row.id);
  };

  const handleCreateButtonClick = () => {
    //this.props.history.push('/technicians/create');
    navigate('/technicians/create');
  };

  if (!loaded) {
    return <div>Loading...</div>; // Render a loading state
  }

  const options = {
    onRowClick: handleRowClick,
  };

  /* render() {
    const { loaded, technicians } = this.state;
    const { areas } = this.props;

    if (!loaded) {
      return <div>Loading...</div>; // Render a loading state
    }

    const options = {
      onRowClick: this.handleRowClick
    };*/

  return (
    <div>
      <Header showLogo>
        <HeaderButtonNav>
          <HeaderButton
            color="primary"
            onClick={handleCreateButtonClick}
            ligature="add"
          />
        </HeaderButtonNav>
        <HeaderTitle label={'Technicians'} />
      </Header>
      <TechnicianListTable
        technicians={technicians}
        options={options}
        areas={props.areas}
        ownProps={props}
        action={props.action}
      />
    </div>
  );
};
//}

function mapStateToProps(state) {
  return { areas: state.referenceData.areas };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(technicianActions, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(TechnicianList);
